/*
 * Copyright (c) 2020 CalAmp Corp.  All Rights Reserved
 */
import React from 'react';
import {IconProps} from '../types/types';
import ThemeIconProvider from './ThemeIconProvider';
import useIconDLS from './useIconDLS';

/*
 * Defines the Design Language System (DLS) Top Nav Filter Icon component.
 */
export const TopNavFilterIcon = (props: IconProps) => {
  const {iconSize, iconColor} = useIconDLS(props);
  return (
    <ThemeIconProvider name='TopNavFilterIcon' {...props} legacyIcon={(
      <svg width={iconSize} height={iconSize} viewBox='0 0 24 24' fill='none'>
        <path d='M1 5.25h3.75m4 0h14.5'
          stroke={iconColor}
          strokeWidth={1.5}
          strokeLinecap='round'
          strokeLinejoin='round' />
        <circle cx={6.75}
          cy={5.5}
          r={1.75}
          stroke={iconColor}
          strokeWidth={1.5} />
        <path d='M1 19.25h3.75m4 0h14.5'
          stroke={iconColor}
          strokeWidth={1.5}
          strokeLinecap='round'
          strokeLinejoin='round' />
        <circle cx={6.75}
          cy={19.5}
          r={1.75}
          stroke={iconColor}
          strokeWidth={1.5} />
        <path d='M1 12.25h13.75m4 0h4.5'
          stroke={iconColor}
          strokeWidth={1.5}
          strokeLinecap='round'
          strokeLinejoin='round' />
        <circle cx={16.75}
          cy={12.5}
          r={1.75}
          stroke={iconColor}
          strokeWidth={1.5} />
      </svg>
    )} />
  );
};

export default TopNavFilterIcon;
